/* istanbul ignore file*/
import { IOption } from 'src/app/model/sitefinity/IFormField';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, filter, finalize, switchMap } from 'rxjs/operators';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { IBrand } from 'src/app/model/claims/IBrand';
import { ISSPCategory } from 'src/app/model/claims/ISSPCategoryMapping';
import { IDeviceInfo, IDeviceInfoDropdown, IDeviceInfoWithError, IRegisteredDevice } from '../claims-flow.component';
import { Observable, of } from 'rxjs';
import { DeviceRegistrationService } from 'src/app/core/services/device-registration.service';
import { GSSPAuthenticationService } from 'src/app/core/services/gssp-authentication.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ICategory } from 'src/app/model/device-inventory/ICategory';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { PGHDateAdapter } from 'src/app/shared/pghDateAdapter';
import { Platform } from '@angular/cdk/platform';
import { UtilityService } from '../../../../../core/services/utility.service';
import { ElitaChildCertificateResponseDto } from 'src/app/model/account/elita-child-certificate-response.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { ADPResourceService } from 'digital-core';
import isBefore from 'date-fns/isBefore';
import { GlobalModalWindowService } from 'src/app/core/services/global-modal-window.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM DD YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM DD YYYY',
  },
};
@Component({
  selector: 'pgh-claims-question',
  templateUrl: './claims-question.component.html',
  styleUrls: ['./claims-question.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: PGHDateAdapter,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ClaimsQuestionComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() options: IOption[];
  @Input() moreInfo: string;
  @Input() finalText: string;
  @Input() buttonText: string;
  @Input() deviceInfo = null;
  @Input() divider = false;
  @Input() categoriesDropdown: IDeviceInfoDropdown;
  @Input() categoriesDropdownMessage: IDeviceInfoWithError;
  @Input() subCategoriesDropdown: IDeviceInfoDropdown;
  @Input() sspCategories: ISSPCategory[];
  @Input() brandsSearchBox: IDeviceInfoWithError;
  @Input() modelTextBox: IDeviceInfo;
  @Input() deviceNameTextBox: IDeviceInfo;
  @Input() serialNumberTextBox: IDeviceInfo;
  @Input() purchasePriceTextBox: IDeviceInfo;
  @Input() purchaseDateTextBox: IDeviceInfo;
  @Input() categoriesDropdownOptions: ICategory[];
  @Input() selectedDevice: PghUserDeviceBase;
  @Input() childCertNumber$: Observable<ElitaChildCertificateResponseDto>; // Only subscribe to this when is GSSP is true.

  isGSSP: boolean;
  dealerCode: string;
  masterCertificateNumber: string;
  coverageTypeCode: string;

  @Output() chooseAnswer = new EventEmitter();

  answer: string;
  filteredBrands: IBrand[] = [];
  isLoading = false;
  isClaimLoading = false;
  claimsForm: UntypedFormGroup;

  contractId: string;
  category: string;
  code: string;
  brand: string;
  model: string;
  deviceName: string;
  serialNumber: string;
  purchasePrice: number;
  purchaseDate: string;

  customDirty = false;
  registeredDevice = {} as IRegisteredDevice;
  brandResultsReturned = 10;

  minDate: Date;
  maxDate: Date = new Date();
  isNative: any;

  constructor(
    private claimsService: ClaimsService,
    private fb: UntypedFormBuilder,
    private loggedInUserSettings: LoggedInUserSettings,
    private deviceRegistrationService: DeviceRegistrationService,
    private gsspAuthService: GSSPAuthenticationService,
    public route: ActivatedRoute,
    private utilityService: UtilityService,
    public resourceService: ADPResourceService,
    private globalModalWindowService: GlobalModalWindowService
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isNative = (params.isNative && params.isNative.toLowerCase().trim() === 'true') || this.utilityService.isNativeApp;
    });


    this.loggedInUserSettings.$selectedContract
      .pipe(filter(selectedContract => !!selectedContract)).subscribe(selected => {
        this.contractId = selected.id;
        this.dealerCode = selected.dealerId;

        console.log(this.registeredDevice);

        this.isGSSP = selected.useGSSPClaims; // change this
        if (this.isGSSP) {
          this.masterCertificateNumber = this.dealerCode + this.contractId;
          this.coverageTypeCode = 'AD';
          this.claimsForm = this.fb.group({
            category: ['', [
              Validators.required
            ]],
            brand: [this.selectedDevice?.make ?? '', [
              Validators.required, Validators.minLength(2)
            ]],
            model: [this.selectedDevice?.model ?? '', [
              Validators.required
            ]],
            deviceName: [this.selectedDevice?.nickName ?? '', [
              Validators.required
            ]],
            serialNumber: ['', []],
            purchasePrice: ['', [
              Validators.required
            ]],
            purchaseDate: ['', [
              Validators.required,
              this.validateMaxDate.bind(this)
            ]],
          });

          this.isSubCategoryHidden = () => true;
        }
        else {
          this.claimsForm = this.fb.group({
            category: ['', [
              Validators.required
            ]],
            subCategory: ['', [
              this.subCategoryConditionallyRequiredValidator
            ]],
            brand: ['', [
              Validators.required
            ]],
            model: ['', [
              Validators.required
            ]]
          });
        }
      });
    this.claimsForm
      .get('brand')
      .valueChanges
      .pipe(
        filter(val => val.length >= 2),
        debounceTime(500),
        switchMap((value: string) => this.filterBrandsAsync(value)
          .pipe(
            finalize(() => this.isLoading = false),
          )
        )
      )
      .subscribe((result) => {
        this.filteredBrands = result;
        if (!this.isGSSP && !this.isSubCategoryHidden) {
          this.claimsForm.get('subCategory').updateValueAndValidity();
        }

        const searchValue = this.claimsForm.get('brand').value;
        this.claimsForm.get('brand').setErrors(this.requireMatch(searchValue));
      });
  }

  ngOnDestroy(): void {
  }

  filterBrandsAsync(val: string): Observable<IBrand[]> {
    if (val.length > 1) {
      this.isLoading = true;
      this.customDirty = true;
      return this.claimsService.getBrandsList(val, this.brandResultsReturned, this.isGSSP);
    }
    else {
      return of<IBrand[]>([]);
    }
  }

  subCategoryConditionallyRequiredValidator = (formControl: AbstractControl) => {
    if (!formControl.parent) {
      return null;
    }

    if (!this.isGSSP && !this.isSubCategoryHidden()) {
      return Validators.required(formControl);
    }
    return null;
  }

  requireMatch = (value: string) => {
    if (((this.filteredBrands.length === 0) ||
      (this.filteredBrands.length > 0 && this.filteredBrands.filter(b => b.brandName.toLowerCase() === value.toLowerCase()).length === 0)
    )) {
      return { requireMatch: true };
    }
    else {
      return null;
    }
  }

  isSubCategoryHidden(): boolean {
    return this.isGSSP ? true : !this.claimsForm.get('category')?.value || this.sspCategories.find(c => c.categoryId === this.claimsForm.get('category')?.value?.categoryId)?.subType.length === 1;
  }

  getSubcategories() {
    return this.sspCategories.find(c => c.categoryId === this.claimsForm.get('category')?.value?.categoryId)?.subType;
  }

  setRegisteredDeviceInfo(certificateNumber: string) {
    this.registeredDevice.certificateNumber = certificateNumber;
    this.registeredDevice.dealerCode = this.dealerCode;
    this.registeredDevice.purchasedDate = this.purchaseDate ? new Date(this.purchaseDate) : new Date();
    this.registeredDevice.manufacturer = this.brand;
    this.registeredDevice.model = this.model;
    this.registeredDevice.registeredItemName = this.deviceName;
    this.registeredDevice.purchasePrice = !isNaN(this.purchasePrice) ? this.purchasePrice : 0.0;
    this.registeredDevice.deviceTypeCode = this.category;
    this.registeredDevice.serialNumber = this.serialNumber;
  }

  redirectToGSSPFileClaimLink(gsspAuthToken): void {
    const redirectUrl = this.gsspAuthService.generateFileClaimLink(gsspAuthToken);
    if (this.isNative) {
      window.open(redirectUrl, '_self');
    } else {
      this.isClaimLoading = false;
      window.open(redirectUrl, '_self');
    }
  }

  submitClaim() {
    this.isClaimLoading = true;

    if (this.isGSSP) {
      this.category = this.claimsForm.get('category').value?.categoryId;
    } else {
      this.category = this.sspCategories?.find(c => c.categoryId === this.claimsForm.get('category').value?.categoryId).sspCategory;
      const sspCateg = this.sspCategories?.find(c => c.categoryId === this.claimsForm.get('category').value?.categoryId);
      if (this.isSubCategoryHidden()) {
        this.code = sspCateg.subType && sspCateg.subType.length ? sspCateg.subType[0].sspCode : '';
      }
      else {
        this.code = sspCateg.subType?.find(c => c.name === this.claimsForm.get('subCategory').value.name).sspCode;
      }
    }
    this.brand = this.claimsForm.get('brand').value;
    this.model = this.claimsForm.get('model').value;
    if (this.isGSSP) {
      this.deviceName = this.claimsForm.get('deviceName').value;
      this.serialNumber = this.claimsForm.get('serialNumber').value;
      this.purchasePrice = this.claimsForm.get('purchasePrice').value;
      this.purchaseDate = this.claimsForm.get('purchaseDate').value;

      this.childCertNumber$.subscribe({
        next: (certNumResp) => {
          this.setRegisteredDeviceInfo(certNumResp.childCertificateNumber);

          // call register Device, then gssp claims page
          this.deviceRegistrationService.registerDevice(this.registeredDevice).subscribe({
            next: (device: any) => {
              if (device && device.certificateNumber && device.certificateNumber.length > 0) {
                const childCertificateNumbers: [string] = [device.certificateNumber];
                this.gsspAuthService.postGenerateGSSPToken(this.dealerCode, this.masterCertificateNumber, childCertificateNumbers, device).subscribe({
                  next: (gsspAuthToken: any) => {
                    if (gsspAuthToken.length > 0) {
                      this.redirectToGSSPFileClaimLink(gsspAuthToken);
                    }
                    else {
                      this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_InvalidGsspAuthToken_Title', 'GetGsspAuthToken');
                    }
                  }, error: (err) => {
                    this.isClaimLoading = false;
                    throw err;
                  }
                });
              } else {
                this.globalModalWindowService.showModalWindowMin('Global_Modal_Error_MissingMasterCertificate_Title', 'GetGsspAuthToken');
              }
            }, error: (err) => {
              this.isClaimLoading = false;
              throw err;
            }
          });
        },
        error: (err: HttpErrorResponse) => {
          this.isClaimLoading = false;
          throw err;
        },
      });
    }
    else {
      this.claimsService.postClaim(this.resourceService.getPortalSetting("URL_FileClaim").Value, this.contractId, this.category, this.code, this.brand, this.model).subscribe({
        next: (response) => {
          if (response.url) {
            if (this.isNative) {
              window.open(response.url, '_self');
            } else {
              this.isClaimLoading = false;
              window.open(response.url, '_self');
            }
          } else {
            this.isClaimLoading = false;
          }
        },
        error: (err) => {
          this.isClaimLoading = false;
          throw err;
        }
      });
    }
  }

  validateMaxDate(control: UntypedFormControl) {
    if (control?.value != null) {
      if (isBefore(new Date(), control.value)) {
        return { maxDate: true };
      }
    }
  }
}
